<template>
  <div class="personal-logo">
    <div id="head">
      <div class="logo">
        <div id="logo_left">
          <div class="left">
            <img
            :src="imgUrl"
            @click="doTips"
          >
          </div>
          <div class="right">
            <div class="system_name">{{systemName}}—<span>个人中心</span></div>
            <div class="enterprise-name">({{enterpriseName}})</div>
          </div>
        </div>
        <div id="logo_right">
          <div
            style="display:inline-block;margin-right:20px;overflow:hidden;height:48px;width:48px;"
            v-show="userShow"
          >
            <img style="width:48px;height:48px;background-color:white;border-radius: 4px;" :src="getImgSrc2(headUrl)">
          </div>
          <el-tooltip class="item" effect="dark" :content="name" placement="top" v-show="userShow">
            <el-button
              type="text"
              style="position:relative;color:white;margin-right:20px;top:-20px;border:none"
            >{{name}}</el-button>
          </el-tooltip>
          <el-badge :value="$store.state.unreadMessage" :max="99" class="item" :hidden="$store.state.unreadMessage == 0">
            <el-button  type="text"  @click="$router.push('/trainClass/personalCenter/message')" style="color:white;border:none;">消息</el-button>
          </el-badge>
          <el-button
            type="text"
            v-show="userShow"
            @click="exit_"
            class="item"
            style="color:white;margin-right:50px;position:relative;top:-20px;border:none"
          >退出</el-button>
          <el-button
            type="text"
            v-show="userShow===false"
            @click="doTips"
            style="color: white;margin-left:20px;position:relative;top:-20px;margin-right:10px;margin-top:25px;"
          >登录</el-button>
          <el-button type="text" v-show="userShow===false">
            <router-link
              to="/trainClass/register"
              style="color: white;text-decoration:none;position:relative;top:-20px;margin-right:20px;"
            >注册</router-link>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/Bus"
export default {
    props: ["configData"],
    data () {
        return {
            searchTitle: "",
            userId: '',
            name: "",
            headUrl: "",
            unreadMessage: 0,
            selectedIndex: 0,
            userInfo: {},
            availableTime: '',
            remindTime:{}
            // userShow: false
        }
    },
    created () {
        // this.userShow = sessionStorage.token?true:false

    },
    mounted () {
        if (sessionStorage.loginSecond !== 'second') {
            this.$router.push('/')
        }
        this.selectedIndex = 0
        if (this.$route.name === 'AccountSafty') {
            this.selectedIndex = 2
        }
        if (this.$route.name === 'PersonalInfo') {
            this.selectedIndex = 1
        }
        this.userId = sessionStorage.userUuid

        this.seeAccount()
        this.getUnreadMessage()
        this.getReadMessage()
        this.getAvailableTime()
        this.connectMessage()
        //监听修改个人头像
        Bus.$on('updateUsersDep', () => {
          this.seeAccount()
        });
    },
    computed: {
        userShow () {
            return this.$store.state.userShow
        },
        imgUrl() {
          return this.$store.state.imgUrl
        },
        enterpriseName() {
          return this.$store.state.enterpriseName
        },
        systemName() {
          return this.$store.state.systemName
        }
    },
    methods: {
        seeAccount(){
            this.$ajax.post("/comuser-service/Account/seeAccount", this.postData({
            id: sessionStorage.userUuid
            })).then(res => {
                this.userInfo  = res.data.tbAccount
                //设置证书提醒时间
                this.remindTime = {
                    show:Boolean(this.userInfo.availableTime),
                    ifRemind:this.userInfo.availableTime,
                    time:this.lastDay(this.userInfo.availableTime),
                    availableTime:this.availableTime
                }
                sessionStorage.setItem('remindTime',JSON.stringify(this.remindTime))
                this.name = res.data.tbAccount.userName
                this.headUrl = res.data.tbUser.photoUrl
                sessionStorage.headUrl = this.filesDownload(res.data.tbUser.photoUrl)
                if (this.headUrl === '"null"') {
                    this.headUrl = ''
                }
            })
        },
        async getAvailableTime () {
            const res = await this.$ajax.post("/auth-config-service/dict/getAvailableTime")
            this.availableTime = res.data ? Number.parseInt(res.data) : 60
        },
        lastDay (time) {
            const nowTime = new Date()
            const lastTime = new Date(time)
            const day = (lastTime.getTime() - nowTime.getTime()) / (1000 * 60 * 60 * 24)
            // debugger
            if (day > 0) {
                return Number.parseInt(day) + 1
            } else {
                return 0
            }
        },
        changeNav (route) {
            this.getUnreadMessage()
            this.getReadMessage()
            this.$router.push(route)
        },
        getUnreadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 1,
                        pageNumber: 1,
                        pageSize: 10
                    })
                )
                .then(res => {
                    if (res.code === '200') {
                        this.$store.commit('unreadList', res.data.list)
                        this.$store.commit('unreadMessage', res.data.totalCount)
                    }
                })
        },
        getReadMessage () {
            this.$ajax
                .post(
                    '/enterprise-service/Enterprise/userMessageList',
                    this.postData({
                        userId: sessionStorage.userUuid,
                        state: 0,
                        pageNumber: 1,
                        pageSize: 10
                    })
                )
                .then(res => {
                    if (res.code === '200') {
                        this.$store.commit('readList', res.data.list)
                        this.$store.commit('readTotal', res.data.totalCount)
                    }
                })
        },
        connectMessage () {
            var _this = this

            if ("WebSocket" in window) {
                // 打开一个 web socket
                var ws = new WebSocket("ws://52.83.222.186:3016/websocket")
                ws.onopen = function () {
                    // Web Socket 已连接上，使用 send() 方法发送数据
                    ws.send("发送数据")
                }
                ws.onmessage = function (evt) {
                    // var received_msg = evt.data;
                    var msg = evt.data.split(',')
                    for (let i = 0; i < msg.length; i++) {
                        if (_this.userId === msg[i]) {
                            _this.getUnreadMessage()
                            _this.getReadMessage()
                            break
                        }
                    }
                    console.log("数据已接收...")
                }
                ws.onclose = function () {
                    // 关闭 websocket
                    console.log("连接已关闭...")
                }
            }

        },
        getImgSrc2 (url) {
            if (url) {
                // let first = url.lastIndexOf(":");
                // let last = url.lastIndexOf('"');
                // let finalUrl = url.substring(first + 2, last);
                return this.filesDownload(url)
            } else {
                return
            }
        },
        doTips () {
            console.log(484854);
            // sessionStorage.toPath = "/"
            // this.$router.push("/")
        },
        exit_ () {
            this.$confirm("确定要退出登录", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            }).then(() => {
                sessionStorage.clear()
                this.$store.commit("userShow", false)
                this.$router.push("/login/" + localStorage.enterpriseNum)
            })
        },
        intoCenter () {
            this.$router.push("/trainClass/personalCenter/learnCenter/learnTrain")
        }
    },
    watch: {
        $route (to, from) {
            this.selectedIndex = 0
            if (to.name === 'AccountSafty') {
                this.selectedIndex = 2
            }
            if (to.name === 'PersonalInfo') {
                this.selectedIndex = 1
            }
        }
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.personal-logo {
  #head {
    width: 100%;
    background: linear-gradient(to right, #1060ab , #516dd2); /* 标准的语法 */
    .logo {
      width: 1280px;
      height: 120px;
      margin: 0 auto;
    }
    .el-badge {
      vertical-align: 0;
      top: -20px;
      margin-right: 20px;
    }
    .el-badge__content {
      position: absolute;
      padding: 0;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: none;
      background-color: #ff0000;
      left: 5px;
      top: 5px;
    }

    #logo_left {
      float: left;
      display: flex;
      height: 120px;
      padding-top: 10px;
      .left {
        height: 100%;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .right {
        color: #ffffff;
        line-height: 50px;
        .system_name {
          font-size: 22px;
          span {
            font-weight: 550;
          }
        }
        .enterprise-name {
          font-size: 18px;
        }
      }
    }
    #logo_right {
      float: right;
      margin-top: 35px;
    }
    #login {
      position: absolute;
      top: 30px;
      right: 10px;
      text-align: right;
      font-size: 14px;
      a {
        color: white;
        text-decoration: none;
      }
    }
    #login .el-message-box__header {
      background-color: white;
    }
    #login .el-message-box__title {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/personalCenterHead/logo.vue